// extracted by mini-css-extract-plugin
export default {"socialMedia":"aPVdSWGRY_rrPYB4X3vE"};